import { buildEndpointUrl } from '@/_shared/helpers/makeSwaggerToEndpointUrl';
import { payloadToQueryParamsUrl } from '@/_shared/helpers/payloadToQueryParamsUrl';
import { GenericGet } from '@/_shared/types';
import {
  API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_USER_HISTORY_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_USER_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_USER_SUMMARY_BY_CATEGORY_PATH_KEY,
} from '@/swagger/constants/credits-keys';

export const API_POST_EMPLOYER_CREDITS = (organizationId: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_USER_PATH_KEY, {
    organizationId,
  });
};

export const API_POST_EMPLOYER_CREDITS_SUMMARY_BY_CATEGORY = (organizationId: string) => {
  return buildEndpointUrl(
    API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_USER_SUMMARY_BY_CATEGORY_PATH_KEY,
    {
      organizationId,
    },
  );
};

export const API_POST_EMPLOYER_CREDITS_HISTORY = (organizationId: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_USER_HISTORY_PATH_KEY, {
    organizationId,
  });
};

export const API_GET_EMPLOYER_CREDITS = (organizationId: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_USER_PATH_KEY, {
    organizationId,
  });
};

type RequestGetEmployerCreditsHistory = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_USER_HISTORY_PATH_KEY
>['request']['query'];

export const API_GET_EMPLOYER_CREDITS_HISTORY = (
  organizationId: string,
  params: RequestGetEmployerCreditsHistory,
) => {
  const baseUrl = buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_USER_HISTORY_PATH_KEY, {
    organizationId,
  });
  return payloadToQueryParamsUrl(params, baseUrl);
};
